
import React, { useRef } from 'react';
import dynamic from 'next/dynamic';
import { useResizeObserver } from '@frontend/jetlend-web-ui/src/hooks/useResizeObserver';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';

import styles from './HeaderAchievementSlider.module.scss';
import './slider.scss';

const LazySlide = dynamic(() => import('react-slick').then(module => module), { ssr: false });

const NextArrow = (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M5.36692 11.2662C5.11699 11.5161 4.71176 11.5161 4.46183 11.2662V11.2662C4.21189 11.0163 4.21189 10.611 4.46183 10.3611L7.74335 7.07958C7.8612 6.96173 7.8612 6.77067 7.74335 6.65283L4.46183 3.3713C4.21189 3.12136 4.21189 2.71614 4.46183 2.4662V2.4662C4.71176 2.21627 5.11699 2.21627 5.36692 2.4662L9.30677 6.40605C9.5609 6.66018 9.5609 7.07222 9.30677 7.32636L5.36692 11.2662Z" fill="white" />
    </svg>
);

const PrevArrow = (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.63308 11.2662C8.88301 11.5161 9.28824 11.5161 9.53817 11.2662V11.2662C9.78811 11.0163 9.78811 10.611 9.53817 10.3611L6.25665 7.07958C6.1388 6.96173 6.1388 6.77067 6.25665 6.65283L9.53817 3.3713C9.78811 3.12136 9.78811 2.71614 9.53817 2.4662V2.4662C9.28824 2.21627 8.88301 2.21627 8.63308 2.4662L4.69323 6.40605C4.4391 6.66018 4.4391 7.07222 4.69323 7.32636L8.63308 11.2662Z" fill="white" />
    </svg>
);

/**
 * Компонент для отрисовки слайдера ачивок
 */
const HeaderAchievementSlider = props => {
    const { children } = props;

    const sliderRef = useRef<HTMLDivElement>(null);
    const [width] = useResizeObserver(sliderRef);
    const maxCount  = Math.ceil(width / 70);
    const isArrowsShow = children?.length > maxCount;

    const SLIDER_SETTINGS = {
        children: [],
        arrows: isArrowsShow,
        indicators: false,
        autoplay: false,
        infinite: false,
        duration: 1200,
        transitionDuration: 400,
        canSwipe: true,
        ref: sliderRef,
        slidesToShow: maxCount,
        slidesToScroll: 1,
        prevArrow: PrevArrow,
        nextArrow: NextArrow,
        className: 'achievements-slider',
    };

    const containerClassName = buildClassNames(styles, [
        'container',
        !isArrowsShow && 'container--margin',
    ]);

    return (
        <div ref={sliderRef} className={containerClassName}>
            <LazySlide {...SLIDER_SETTINGS}>
                {children?.map((child, i) => (
                    <React.Fragment key={i}>
                        <div className={styles['item-wrapper']}>{child}</div>
                    </React.Fragment>
                ))}
            </LazySlide>
        </div>
    );
};

export default HeaderAchievementSlider;